import { render, staticRenderFns } from "./EpEmptyData.vue?vue&type=template&id=03ff51e6&"
import script from "./EpEmptyData.vue?vue&type=script&lang=js&"
export * from "./EpEmptyData.vue?vue&type=script&lang=js&"
import style0 from "./EpEmptyData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports